<template>
    <div class="area-acompanhamento">
        <div>
            <div class="area-acompanhamento__info" v-if="acompanhamento.dataHoraPublicacao">
                <i class="far fa-clock" aria-hidden="true"/>
                <div class="area-acompanhamento__texto">
                    <h3 class="orange--text text-uppercase">Consulta publicada!</h3>
                    <p class="area-acompanhamento__descricao">
                        Por {{acompanhamento.criadoPor}} em
                        {{acompanhamento.dataHoraPublicacao |
                        az-date(humanizarFormatoDataHora(acompanhamento.dataHoraPublicacao))}}
                        <span v-if="acompanhamento.dataHoraEncerramento">,
                            e se encerra em
                            {{acompanhamento.dataHoraEncerramento |
                            az-date(humanizarFormatoDataHora(acompanhamento.dataHoraEncerramento))}}
                        </span>
                        <span v-else>, sem data definida para encerramento.</span>
                    </p>
                    <p>
                        Para acessar o resultado e visualizar os licitantes vencedores e seus documentos, é necessário
                        aguardar o encerramento.
                    </p>
                </div>
            </div>

            <div class="area-acompanhamento__acoes" v-if="acompanhamento.dataHoraPublicacao">
                <a
                   @click="tratarEventoCliqueDownload(tiposDocumento.CONSULTA_DE_COMPRA_DIRETA)"
                   target="_blank"
                   class="botao d-flex align-center">
                    <i class="fas fa-download mr-2" aria-hidden="true"/>
                    Consulta de Compra Direta
                </a>

                <a
                   @click="tratarEventoCliqueDownload(tiposDocumento.FORNECEDORES_NOTIFICADOS)"
                   target="_blank"
                   class="botao d-flex align-center">
                    <i class="fas fa-download mr-2" aria-hidden="true"/>
                    Fornecedores Notificados
                </a>

                <a v-if="ehCompraVirtualizada && !mostrarProcessoEdocs()"
                   :href="resumoCompraDireta.processoVirtualUrl"
                   target="_blank"
                   style="text-decoration: none;"
                   class="botao d-flex align-center">
                    <i class="fas fa-book mr-2" aria-hidden="true"/>
                    Processo Digital
                </a>

              <button v-if="ehCompraVirtualizada && mostrarProcessoEdocs()"
                      @click="acessarProcessoDigital"
                      type="button"
                      class="botao d-flex align-center">
                <i class="fas fa-book mr-2" aria-hidden="true"/>
                Acessar e-Docs
              </button>

                <a v-if="resumoCompraDireta.recursoFederal && resumoCompraDireta.tipoTransferencia !== 'OUTRAS'"
                   @click="baixarRelatorioMaisBrasil"
                   target="_blank"
                   class="botao d-flex align-center">
                    <i class="fas fa-download mr-2" aria-hidden="true"/>
                    Relatorio Mais Brasil
                </a>

            </div>

            <acompanhamento-tabela
                    v-model="acompanhamento.lances"
                    v-if="acompanhamento.dataHoraPublicacao"
                    :casasDecimais="quantidadeCasasDecimais"
                    :prefixo="prefixoValor"
                    :tipoCompraDireta="acompanhamento.tipo"
            />

            <div class="area-acompanhamento__info" v-if="!acompanhamento.dataHoraPublicacao">
                <i class="far fa-sad-tear" aria-hidden="true"/>
                <div class="area-acompanhamento__texto">
                    <h3 class="orange--text text-uppercase">Consulta sem data de publicação!</h3>
                    <p class="area-acompanhamento__descricao">
                        Por algum motivo esta compra direta está sem a data/hora de publicação.
                    </p>
                </div>
            </div>
            <div class="az-actions-form ajuste-acoes">
                <botao-voltar @voltar="tratarEventoVoltar"/>
                <botao-avancar @avancar="tratarEventoAvancar" v-if="exibirBotaoAvancar"/>
            </div>
        </div>

        <modal-opcoes-download
                :exibirModal="mostrarOpcoesDownload"
                @selecionarOpcao="downloadDocumentoVirtualizado"
                @fechar="fecharOpcoesDownload">
        </modal-opcoes-download>

        <v-snackbar
            v-model="mostrarAlertaErro"
            :timeout="6000"
            top
            right
            color="warning"
        >
            <v-icon color="white" class="mr-2">warning</v-icon>
            {{ mensagemErro }}
            <v-btn
                flat
                color="white"
                @click="mostrarAlertaErro = false"
            >
              <v-icon>close</v-icon>
            </v-btn>
        </v-snackbar>
    </div>
</template>

<script>
import SmartTimerMixin from '@/core/mixins/SmartTimerMixin'
import {mapState} from 'vuex'
import {actionTypes} from '@/core/constants'
import AcompanhamentoTabela from '@/views/pages/comprador/execucao-compra-direta/acompanhamento/AcompanhamentoTabela'

export default {
    name: 'Acompanhamento',
    mixins: [SmartTimerMixin],
    components: {
        AcompanhamentoTabela,
    },
    data() {
        return {
            compraDiretaId: null,
            tiposDocumento: Object.freeze({'FORNECEDORES_NOTIFICADOS':1, 'CONSULTA_DE_COMPRA_DIRETA':2, 'PROCESSO_DIGITAL':3}),
            documentoParaBaixar: null,
            mostrarOpcoesDownload: false,
            mostrarAlertaErro: false,
            mensagemErro: ''
        }
    },
    computed: {
        acompanhamento() {
            const cd = this.compraDireta || {}
            return cd.acompanhamento || {}
        },
        ...mapState(['compraDireta', 'parametros', 'resumoCompraDireta']),
        exibirBotaoAvancar() {
            const sit = this.acompanhamento.situacao
            return (sit === 'EM_ANALISE' || sit === 'REANALISE' || sit === 'ENCERRADA' || (sit === 'SUSPENSA' && this.acompanhamento.suspensaoPosAnalise === true))
        },
        quantidadeCasasDecimais() {
            if (this.acompanhamento.tipo === 'COM_DISPUTA' && this.acompanhamento.disputaPor === 'UNITARIO') {
                return this.acompanhamento.casaDecimal
            }
            return 2
        },
        prefixoValor() {
            if (this.acompanhamento && this.acompanhamento.prefixoValor) {
                return this.acompanhamento.prefixoValor
            }
            return 'R$'
        },
        ehCompraVirtualizada(){
            return this.resumoCompraDireta.virtualizada
        }
    },
    async mounted() {
        try {
            this.setCompraDiretaId()
            await this.buscarDadosAcompanhamento()
            this.desabilitarLoadingGlobal()
        } catch (e) {
            this.mostrarNotificacaoErro(e.message)
        }
        
        this.createSmartTimer('verificarSePodeAtualizarDadosAcompanhamento', 'verificarSePodeAtualizarDadosAcompanhamento', 60000, {
            autostart: true,
            immediate: true
        })
    },
    methods: {
        async baixarRelatorioMaisBrasil(){
            this.setMensagemLoading('Baixando relatório...')
            await this.$store.dispatch(actionTypes.BAIXAR_RELATORIO_MAIS_BRASIL, {compraDiretaId: this.compraDiretaId})
        },
        mostrarProcessoEdocs(){
            return this.parametros.propriedadesCompraDiretas.identidadeCliente === 'ES' &&
                this.parametros.propriedadesCompraDiretas.integration.edocs.ativo === true
        },
        async acessarProcessoDigital () {
            try {
                const data = await this.$store.dispatch(actionTypes.COMPRADOR.ACESSAR_EDOCS, this.resumoCompraDireta.processoVirtual)

                if (data && data.url) {
                    window.location.href = data.url
                }
            } catch (error) {
                if (error.response && error.response.status === 500) {
                    this.mensagemErro = 'Não é possível acessar o processo no e-Docs pois ainda não foi enviado nenhum documento.'
                    this.mostrarAlertaErro = true
                } else {
                    this.mensagemErro = 'Erro ao tentar acessar o processo digital. Tente novamente.'
                    this.mostrarAlertaErro = true
                }
            }
        },
        async buscarDadosAcompanhamento() {
            await this.$store.dispatch(actionTypes.COMPRADOR.BUSCAR_DADOS_ACOMPANHAMENTO, this.compraDiretaId)
        },
        async verificarSePodeAtualizarDadosAcompanhamento() {
            if ((this.acompanhamento.situacao === 'ABERTA') && (this.acompanhamento.tipo === 'COM_DISPUTA')) {
                await this.buscarDadosAcompanhamento()
            }
        },
        async downloadDocumentoVirtualizado(opcaoDownloadVirtualizacao){
            const infoObj = {
                idVirtualizado: this.getIdDocumentoVirtualizado(this.documentoParaBaixar),
                opcaoDownloadVirtualizacao: opcaoDownloadVirtualizacao,
                compraDiretaId: this.compraDiretaId,
                uri: null,
                noProcessoDigital: true
            }
            await this.chamarActionDownload(infoObj)
            this.fecharOpcoesDownload(infoObj)
        },
        async downloadDocumentoNaoVirtualizado(uri){
            const infoObj = {
                idVirtualizado: null,
                opcaoDownloadVirtualizacao: 'ORIGINAL',
                compraDiretaId: this.compraDiretaId,
                uri: uri,
                noProcessoDigital: false
            }
            
            if(this.deveBaixarDoEndPoint(infoObj))
                await this.dispararActionDownloadEndPoint(infoObj)
            else
                await this.chamarActionDownload(infoObj)
        },
        async dispararActionDownloadEndPoint(infoObj){
            if(this.documentoParaBaixar === this.tiposDocumento.CONSULTA_DE_COMPRA_DIRETA)
                await this.$store.dispatch(actionTypes.COMPRADOR.BAIXAR_RELATORIO_CAPA_COMPRA_DIRETA_END_POINT, infoObj)
            else if(this.documentoParaBaixar === this.tiposDocumento.FORNECEDORES_NOTIFICADOS){
                await this.$store.dispatch(actionTypes.COMPRADOR.BAIXAR_RELATORIO_FORNECEDORES_NOTIFICADOS_END_POINT, infoObj)
            }
            this.documentoParaBaixar = null
        },
        async chamarActionDownload(infoObj){
            if(this.documentoParaBaixar === this.tiposDocumento.CONSULTA_DE_COMPRA_DIRETA)
                await this.$store.dispatch(actionTypes.COMPRADOR.BAIXAR_RELATORIO_CAPA_COMPRA_DIRETA, infoObj)
            else if(this.documentoParaBaixar === this.tiposDocumento.FORNECEDORES_NOTIFICADOS){
                await this.$store.dispatch(actionTypes.COMPRADOR.BAIXAR_RELATORIO_FORNECEDORES_NOTIFICADOS, infoObj)
            }
            this.documentoParaBaixar = null
        },
        getIdDocumentoVirtualizado(tipo){
            if(tipo === this.tiposDocumento.CONSULTA_DE_COMPRA_DIRETA){
                return this.acompanhamento.idConsultaCompraDiretaVirtualizado
            }
            if(tipo === this.tiposDocumento.FORNECEDORES_NOTIFICADOS){
                return this.acompanhamento.idFornecedoresNotificadosVirtualizado
            }
            return null
        },
        getUriFilemanagerPorTipoDocumento(tipo){
            if(tipo === this.tiposDocumento.FORNECEDORES_NOTIFICADOS)
                return this.acompanhamento.uriRelatorioFonecedoresNotificados
            if(tipo === this.tiposDocumento.CONSULTA_DE_COMPRA_DIRETA)
                return this.acompanhamento.uriRelatorioConsultaCompraDireta
            return null
        },
        tratarEventoVoltar() {
            this.$router.push({name: 'DocumentosVisualizacao', params: this.compraDiretaId})
        },
        tratarEventoAvancar() {
            this.$router.push({name: 'Resultado', params: this.compraDiretaId})
        },
        setCompraDiretaId() {
            this.compraDiretaId = this.$route.params.id
        },
        abrirOpcoesDownload(){
            this.mostrarOpcoesDownload = true
        },
        fecharOpcoesDownload(){
            this.mostrarOpcoesDownload = false
        },
        tratarEventoCliqueDownload(tipoDocumento) {
            this.documentoParaBaixar = tipoDocumento
            const idDocumento = this.getIdDocumentoVirtualizado(tipoDocumento)
            if (idDocumento != null) {
                return this.abrirOpcoesDownload(tipoDocumento)
            }
            const uri = this.getUriFilemanagerPorTipoDocumento(this.documentoParaBaixar)
            if (uri != null) {
                return this.downloadDocumentoNaoVirtualizado(uri)
            }

            throw new Error('Id documento não encontrado')
        },
        deveBaixarDoEndPoint(infoObj)
        {
            return infoObj.uri === null || infoObj.uri.trim() === ''
        }
    }
}
</script>

<style scoped lang="stylus">
    .area-acompanhamento
        color #888

        &__info
            display flex
            justify-content center
            align-items center
            margin 0 auto
            padding 3rem
            box-sizing border-box
            border-bottom 1px solid #ebebeb

        .far
            font-size 60px
            color #888

        &__texto
            margin-left 24px

            p
                margin-bottom 0

        &__descricao
            font-weight bold
            color #777

        &__acoes
            display flex
            justify-content center
            align-items center
            margin 2rem auto

            .botao
                background-color #e4e4e4 !important
                color #444 !important
                padding 5px 15px
                margin-right 30px
                border-radius 2px

            .botao:hover, .botao:focus, .botao:active
                background-color #bababa !important

            .botao:last-child
                margin-right 0

    @media (max-width 720px)
        .area-acompanhamento
            &__info
                flex-direction column

            &__texto
                margin-left 0
                margin-top 20px
                text-align center

            &__acoes
                margin 2rem
                flex-direction column

                .botao
                    margin 0 0 30px

                .botao:last-child
                    margin 0

    @media (max-width 500px)
        .area-acompanhamento .far
            font-size 40px
</style>
